import { z } from 'zod';

import { accountNumberValidation } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantCashInCashOutMethod/constants/accountNumberValidation';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const MerchantCashInCashOutMethodSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      accountHolderFirstName: requiredString(t),
      accountHolderLastName: requiredString(t),
      accountNumber: requiredString(t),
      description: requiredString(t),
    })
    .strict()
    .refine(
      (data) =>
        accountNumberValidation({ accountNumber: data.accountNumber, selectedBank: data.description }).isValidIban(),
      {
        message: t('ACCOUNT_NUMBER_IS_NOT_VALID'),
        path: ['accountNumber'],
      },
    )
    .refine(
      (data) =>
        accountNumberValidation({
          accountNumber: data.accountNumber,
          selectedBank: data.description,
        }).bankExistsInTable(),
      {
        message: t('BANK_RELATED_TO_ACCOUNT_NUMBER_DOES_NOT_EXIST_IN_TABLE'),
        path: ['accountNumber'],
      },
    )
    .refine(
      (data) =>
        accountNumberValidation({
          accountNumber: data.accountNumber,
          selectedBank: data.description,
        }).bankDoesNotMatchTheSelectedBank(),
      {
        message: t('BANK_ACCOUNT_NUMBER_DOES_NOT_MATCHES_THE_SELECTED_BANK'),
        path: ['accountNumber'],
      },
    );

export type MerchantCashInCashOutMethodType = z.infer<ReturnType<typeof MerchantCashInCashOutMethodSchema>>;
